// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".w2uWDfmyU1IoqvqfHgyz{margin:10px 15px}.Tns7NyRWF_X8aUnKObh4{opacity:.5}", "",{"version":3,"sources":["webpack://./src/templates/progress/hiddenForSectionToggle.module.scss"],"names":[],"mappings":"AAAA,sBACE,gBAAA,CAGF,sBACE,UAAA","sourcesContent":[".toggle {\n  margin: 10px 15px;\n}\n\n.disabled {\n  opacity: 0.5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toggle": "w2uWDfmyU1IoqvqfHgyz",
	"disabled": "Tns7NyRWF_X8aUnKObh4"
};
export default ___CSS_LOADER_EXPORT___;
